import { useState } from "react";
import DataStore from "../../../../../services/DataStore";

export default function useLevels() {
  const [levels, setLevels] = useState([]);

  const fetchLevel = async (id) => {
    try {
      const {data} = await DataStore.getOptions({
        entity: 'AdministrativeLevel',
        filters: { ids: [id] }
      });

      if (Array.isArray(data) && data[0]) {
        setLevels((p) => [...p, data[0]]);
      }
    } catch (err) {
      console.log(err);
    }
  }

  const getName = (id) => {
    const level = levels.find(l => l.id === id)
    return level?.name || '...';
  }

  return {
    getName,
    fetchLevel,
  };
}

